import React, { useState } from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { Formik, Field, Form } from "formik";
import { GET_CONTRACT_ADD } from "../../../../helpers/queries";
import { showLoading, hideLoading } from "../../../../reducers/app";
import Modal from "../../../common/Modal/Modal";
import "./addContract.scss";
import { client } from "../../../../App";

const AssociateContractsAddForm = (props: any) => {
  const { t } = props;
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  let schemaValidation = () => {
    return Yup.object().shape({
      codiceCliente: Yup.string().required(
        t("errors.addContact.validation.required")
      ),
      numeroFattura: Yup.string().required(
        t("error.addBill.validation.required")
      ),
    });
  };

  const handleChange = (data: any) => {
    props.sendData(data);
  };

  return (
    <div
      className={"AddContractForm mt-5 container"}
      data-testid="AddContractForm"
    >
          <Formik
            initialValues={{
              codiceCliente: "",
              numeroFattura: "",
            }}
            validationSchema={schemaValidation}
            onSubmit={async (value) => {
              dispatch(showLoading());
              client()
                .query({
                  query: GET_CONTRACT_ADD,
                  variables: {
                    integraContractCode: value.codiceCliente,
                    invoiceNumber: value.numeroFattura,
                    operation: "ASSOCIAZIONE_CONTRATTO",
                  },
                })
                .then(({ data }) => {
                  handleChange([data.searchContract]);
                  props.sendError(null);
                  dispatch(hideLoading());
                })
                .catch((error: any) => {
                  props.sendError(error);
                  dispatch(hideLoading());
                });
            }}
          >
            {({ errors, touched }) => (
              <Form noValidate>
                <div className="row">
                  <div className="col-xs-12 col-md-12 text-left">
                    <div className={"row"}>
                      <div className="form-info col-sm-12 mb-5">
                        <p className={"case-step-mandatory-fields-legend paragraph-small-fs9"}>{t("mandatory.fields.legend")}</p>
                        <h2 className="mb-5 headline-bold-fs5">{t("common.addContracts")}</h2>
                        <p className="headline-fs6">{t("common.addContractsInfo")}</p>
                      </div>

                      <div
                        style={{ paddingLeft: "0px" }}
                        className="col-lg-4 col-md-12"
                      >
                        <div className={"form-group"}>
                          <label
                            className="paragraph-small-fs9"
                            htmlFor="codiceCliente"
                          >
                            {t("common.clientCode")}{" "}
                            <button
                              type="button"
                              className={"form-info-button"}
                              aria-label={t("aria.form.info.button")}
                              aria-haspopup="dialog"
                              aria-controls={"codiceCliente-info-modal"}
                              onClick={() => setIsOpen(true)}
                            >
                              <span
                                className="form-icon-info"
                                aria-hidden="true"
                              ></span>
                            </button>
                          </label>
                          <Field
                            title="Codice Contratto"
                            name={"codiceCliente"}
                            type="text"
                            id="codiceCliente"
                            className={
                              errors.codiceCliente && touched.codiceCliente
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            placeholder={t("common.codiceClient")}
                            aria-describedby={
                              errors.codiceCliente && touched.codiceCliente
                                ? "codiceCliente-error"
                                : null
                            }
                            required={true}
                          />
                          {errors.codiceCliente && touched.codiceCliente ? (
                            <p
                              className="form-error-text paragraph-small-form"
                              role="alert"
                              id={"codiceCliente-error"}
                            >
                              {errors.codiceCliente}
                            </p>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-12">
                        <div
                          className={
                            errors.codiceCliente && touched.codiceCliente
                              ? "form-group has-error"
                              : "form-group"
                          }
                        >
                          <label
                            className="paragraph-small-fs9"
                            htmlFor="numeroFattura"
                          >
                            {t("common.billNumber")}
                          </label>
                          <Field
                            title="Numero Fattura"
                            name={"numeroFattura"}
                            type="text"
                            id="numeroFattura"
                            className={
                              errors.numeroFattura && touched.numeroFattura
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            placeholder={t("common.codiceFattura")}
                            required={true}
                            aria-describedby={
                              errors.numeroFattura && touched.numeroFattura
                                ? "numeroFattura-error"
                                : null
                            }
                          />
                          {errors.numeroFattura && touched.numeroFattura ? (
                            <p
                              className="form-error-text paragraph-small-form"
                              role="alert"
                              id={"numeroFattura-error"}
                            >
                              {errors.numeroFattura}
                            </p>
                          ) : null}
                        </div>
                      </div>
                      <div className="submit-holder col-lg-4 col-md-12">
                        <div className="form-group">
                          <label className="form-label" htmlFor="submit">
                            &nbsp;
                          </label>
                          <button
                            type="submit"
                            id="submit"
                            className={"btn btn-primary"}
                          >
                            {t("common.inserisci")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
      <Modal
        show={isOpen}
        onClose={() => setIsOpen(false)}
        description={t('cases.contracts.add.codice_contratto.info.desc')}
        type={"button"}
        onFirstClick={() => setIsOpen(false)}
        linkTitle={t('common.hoCapito')}
      />
    </div>
  );
};

export default AssociateContractsAddForm;
